const t = {
  name: "Chain1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.543 3.53301C15.5935 1.48249 18.9066 1.48249 20.9572 3.53301C23.0077 5.58353 23.0077 8.8967 20.9572 10.9472L16.6601 15.2443L15.2458 13.8301L19.543 9.53301C20.8124 8.26353 20.8124 6.2167 19.543 4.94722C18.2735 3.67775 16.2266 3.67775 14.9572 4.94722L10.6601 9.24433L9.24585 7.83012L13.543 3.53301Z" fill="currentColor"/>
<path d="M9.24433 10.6601L4.94722 14.9572C3.67775 16.2267 3.67775 18.2735 4.94722 19.543C6.2167 20.8125 8.26353 20.8125 9.53301 19.543L13.8301 15.2459L15.2443 16.6601L10.9472 20.9572C8.8967 23.0078 5.58353 23.0078 3.53301 20.9572C1.48249 18.9067 1.48249 15.5935 3.53301 13.543L7.83012 9.24591L9.24433 10.6601Z" fill="currentColor"/>
<path d="M7.24014 18.6544L5.82593 17.2401L17.2401 5.82593L18.6544 7.24014L7.24014 18.6544Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Chain1
};
